// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions {
  display: flex;
  gap: 0.5rem;
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
}
.actions .btn {
  font-size: 1.5rem;
  color: var(--grey-icon);
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
}
.actions .btn:hover {
  color: var(--primary);
  background: rgba(226, 225, 249, 0.33);
}
.actions .btn:active {
  color: var(--primary);
  background: rgba(226, 225, 249, 0.33);
}
.actions .btn:focus {
  color: var(--primary);
  background: rgba(226, 225, 249, 0.33);
}`, "",{"version":3,"sources":["webpack://./src/shared/table/renderers/table-cell-actions-panel/table-cell-actions-panel.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AACF;AACE;EACE,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;AACI;EACE,qBAAA;EACA,qCAAA;AACN;AAEI;EACE,qBAAA;EACA,qCAAA;AAAN;AAGI;EACE,qBAAA;EACA,qCAAA;AADN","sourcesContent":[".actions {\n  display: flex;\n  gap: 0.5rem;\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  transform: translateY(-50%);\n\n  & .btn {\n    font-size: 1.5rem;\n    color: var(--grey-icon);\n    width: 2.4rem;\n    height: 2.4rem;\n    border-radius: 0.4rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: 0.3s;\n\n    &:hover {\n      color: var(--primary);\n      background: rgba(226, 225, 249, 0.33);\n    }\n\n    &:active {\n      color: var(--primary);\n      background: rgba(226, 225, 249, 0.33);\n    }\n\n    &:focus {\n      color: var(--primary);\n      background: rgba(226, 225, 249, 0.33);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
